import { createPlugin, createRoutableExtension } from "@backstage/core-plugin-api";

import { rootRouteRef } from "./routes";

export const orchestratorPlugin = createPlugin({
  id: "orchestrator",
  routes: {
    root: rootRouteRef,
  },
});

export const OrchestratorPage = orchestratorPlugin.provide(
  createRoutableExtension({
    name: "OrchestratorPage",
    component: () =>
      import("./components/OrchestratorPage").then(
        m => m.OrchestratorPage as unknown as (props: unknown) => JSX.Element,
      ),
    mountPoint: rootRouteRef,
  }),
);
